const state = {
  status: "",
  token: "", // token here
  userInfo: {},
  showTranslationsId: false,
  showEnglishToolTip: false,
  isAdmin: false,
  isUnilab: false,
  isDebug: false,
  cordivariId: null,
};

export default state;
